import { Box, Skeleton, Typography } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const FilterSelectBox = ({open, onClick, label, displayValue, disabled, loading, maxWidth, dataTestId}) => {
    return (
      <Box
        onClick={!disabled ? onClick : undefined}
        // A disabled box is not operable, so announcing it as a button sends a
        // screen reader looking for an action that is not there.
        role={disabled ? undefined : "button"}
        aria-disabled={disabled || undefined}
        aria-busy={loading || undefined}
        data-testid={dataTestId}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          border: "1px solid transparent",
          borderColor: open ? "#6D72F6" : "#DEDEDE",
          borderRadius: '4px',
          px: 1.5,
          py: 0.75,
          minWidth: 150,
          maxWidth: maxWidth || "none",
          cursor: disabled ? "default" : "pointer",
          position: 'relative',
          "&:hover": !disabled && {
            borderColor: "#6D72F6",
          },
        }}
      >
        <Typography
          variant="fw500s10lh24c5E758D"
          sx={{
            lineHeight: '12px',
            color: open ? "#6D72F6" : "#686868",
            position: 'absolute',
            top: '-7px',
            left: '8px',
            px: 0.5,
            backgroundColor: "#F9F9F9",
          }}
        >
          {label}
        </Typography>
        {loading ? (
          // The box keeps its frame and label so the row does not reflow when
          // the value lands. An empty box reads as a broken control, which is
          // what this replaced.
          <Skeleton variant="text" width={80} height={24} sx={{ flex: 1, minWidth: 0 }} />
        ) : (
          <Typography
            variant="fw500s12lh24cA2A2A2"
            sx={{
              color: "#2B2B2B",
              lineHeight: '24px',
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              flex: 1,
              minWidth: 0,
            }}
          >
            {displayValue}
          </Typography>
        )}
        {!disabled && (
          <ArrowDropDownIcon fontSize="large" sx={{ color: open ? "#6D72F6" : "#3D4B5A", transform: open ? "rotate(180deg)" : "", flexShrink: 0 }} />
        )}
      </Box>
    )
}

export default FilterSelectBox;
